import { Grid, makeStyles } from "@material-ui/core";
import CircleIcon from "@material-ui/icons/FiberManualRecord";
import { EMeasurementStatus } from "api/enums";
import { lang } from "i18nLang";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatNumberToMonetary } from "utils";

const useStyle = makeStyles((theme) => ({
  chart: {
    "& .recharts-legend-wrapper": {
      bottom: "10px !important",
    },
    "& .recharts-legend-item-text": {
      color: `${theme.palette.gray[900]} !important`,
    },
  },
  tooltipCustom: {
    backgroundColor: theme.palette.gray[600],
    borderRadius: 2,
    padding: "0.5rem",

    "& .label": {
      fontSize: "0.875rem",
      fontWeight: 700,
      color: "#AFCBFF",
      margin: "0 0 0.5rem 0",
    },

    "& .value": {
      fontSize: "0.875rem",
      fontWeight: 400,
      color: "#FFFFFF",
      margin: "0.25rem 0",
    },

    "& .icon": {
      width: 22,
      height: 22,
      marginRight: 5,
    },
  },
}));

const CustomizedAxisYTick = (props: any) => {
  return (
    <text {...props} height="235">
      <tspan x={props.x} dy="0.355em">
        {formatNumberToMonetary(props.payload.value)}
      </tspan>
    </text>
  );
};

const CustomizedAxisXTick = (props: any) => {
  return (
    <g transform={`translate(${props.x},${props.y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill={props.fill}
        transform="rotate(-35)"
      >
        {props.payload.value}
      </text>
    </g>
  );
};

export const CustomizeTooltip = (props: any) => {
  const classes = useStyle();
  const { active, payload, label } = props;

  if (!active || !payload || !payload.length) {
    return <></>;
  }

  return (
    <div className={classes.tooltipCustom}>
      <p className="label">{label}</p>
      {payload.map((p, index) => (
        <Grid key={index} container alignItems="center">
          <CircleIcon className="icon" style={{ color: p.stroke }} />
          <span className="value">{formatNumberToMonetary(p.value)}</span>
        </Grid>
      ))}
    </div>
  );
};

const ContractLineChart = ({ data }: { data: any[] }) => {
  const classes = useStyle();

  return (
    <ResponsiveContainer width="100%" height={340}>
      <LineChart
        className={classes.chart}
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 60,
          bottom: 40,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" tick={<CustomizedAxisXTick />} />
        <YAxis tick={<CustomizedAxisYTick />} />
        <Tooltip content={<CustomizeTooltip />} />
        <Legend iconType="circle" />
        <Line
          type="monotone"
          dataKey={lang(
            `dashboard.measureStatus.${EMeasurementStatus.ANDAMENTO}`
          )}
          stroke="#137CBD"
          strokeWidth={2}
          activeDot={{ r: 6 }}
        />
        <Line
          type="monotone"
          dataKey={lang(
            `dashboard.measureStatus.${EMeasurementStatus.AGUARDANDO}`
          )}
          stroke="#FABE24"
          strokeWidth={2}
          activeDot={{ r: 6 }}
        />
        <Line
          type="monotone"
          dataKey={lang(
            `dashboard.measureStatus.${EMeasurementStatus.APROVADA}`
          )}
          stroke="#424242"
          strokeWidth={2}
          activeDot={{ r: 6 }}
        />
        <Line
          type="monotone"
          dataKey={lang(
            `dashboard.measureStatus.${EMeasurementStatus.FATURADA}`
          )}
          stroke="#0E8755"
          strokeWidth={2}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ContractLineChart;
